<template>
  <div class="container">
    <div class="container__title">
      <h3 class="title text-center">The VIN is not valid</h3>
    </div>
    <div class="container__subtitle">
      <h5 class="subtitle text-center">Do you want to proceed anyways?</h5>
    </div>
    <div class="container__actions">
      <button class="btn btn-block proceed-btn" @click="closeModal('proceed')">Proceed</button>
      <button class="btn btn-block enter-new-btn" @click="closeModal('new')">
        Enter a new Vin
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InvalidVinModal',
  props: {
    modalName: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal(action) {
      this.$modal.hide(this.modalName, { action });
    },
  },
};
</script>
<style lang="scss">
@media (max-width: 576px) {
  #modals-container .vm--container .v--modal.invalid-vin-modal {
    left: 0px !important;
    width: 100% !important;
  }
}
</style>
<style lang="scss" scoped>
h3,
h5 {
  margin: 10px 0;
}
.container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-flow: row wrap;
  background-color: #fff;
  height: 100%;
  padding: 25px;

  &__title {
    flex-basis: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    .title {
      font-size: 29px;
      font-weight: 300;
      letter-spacing: normal;
      color: #f55753;
    }
  }

  &__subtitle {
    flex-basis: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    .subtitle {
      font-size: 19px;
      font-weight: 300;
      letter-spacing: normal;
      color: #2c2c2c;
    }
  }

  &__actions {
    flex-basis: 100%;
    display: flex;
    flex-flow: column wrap;
    padding-top: 15px;

    .proceed-btn {
      color: #fff;
      background-color: #0088d7;
      border-color: #0088d7;
      font-size: 12px;
      font-weight: 700;
    }

    .enter-new-btn {
      color: #5e5e5e;
      background-color: #fff;
      border-color: #f0f0f0;
      font-size: 12px;
      font-weight: 700;
    }
  }
}
</style>
